import { render, staticRenderFns } from "./RelatedBusiness.vue?vue&type=template&id=1b39a488&scoped=true"
import script from "./RelatedBusiness.vue?vue&type=script&lang=js"
export * from "./RelatedBusiness.vue?vue&type=script&lang=js"
import style0 from "./RelatedBusiness.vue?vue&type=style&index=0&id=1b39a488&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b39a488",
  null
  
)

export default component.exports